import type { ReactNode } from 'react';

interface StoryTimelineProps {
  children: ReactNode[];
  startIndex?: number;
}

export function StoryTimeline({ children, startIndex = 0 }: StoryTimelineProps) {
  return (
    <div className="story-funnel story-anim-3">
      {startIndex === 0 && <div className="story-funnel-title">Ad-to-Page Analysis</div>}
      <div className="story-tl">
        {children.map((child, i) => (
          <div className="story-step" key={i}>
            <div className="story-rail">
              <div className="story-nd">{startIndex + i + 1}</div>
            </div>
            <div className="story-arm" />
            {child}
          </div>
        ))}
      </div>
    </div>
  );
}
